//
//
//
//
//
//
//
//
//
//
//
//

export default {
  async asyncData({ params, $content }) {
    const article = await $content('pages', params.slug).fetch()

    return {
      article,
      slug: params.slug,
    }
  },
  head() {
    return {
      title: this.article.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.article.description,
        },

        // Open Graph
        { hid: 'og:title', property: 'og:title', content: this.article.title },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.article.description,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.article.img,
        },
        {
          hid: 'og:image:alt',
          name: 'og:image:alt',
          content: this.article.alt,
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content: `https://justpx.com/${this.slug}`,
        },
        {
          hid: 'og:type',
          name: 'og:type',
          content: 'website',
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          content: 'Justpx',
        },

        // Twitter Card
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.article.title,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.article.description,
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.article.img,
        },
        {
          hid: 'twitter:image:alt',
          name: 'twitter:image:alt',
          content: this.article.alt,
        },
      ],
    }
  },
}
